<template>
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" :width="width" :height="height" viewBox="0 0 24 24">
        <defs>
            <clipPath :id="generatedID + '_clip-Close_White'">
                <rect width="24" height="24"/>
            </clipPath>
        </defs>
        <g :id="generatedID + '_Close_White'" :clip-path="'url(#'+generatedID+'_clip-Close_White)'" >
            <rect width="24" height="24" fill="rgba(81,91,96,0)"/>
            <g :id="generatedID + '_Group_13343'" data-name="Group 13343">
                <path :id="generatedID + '_Path_62'"  data-name="Path 62" d="M0,0H24V24H0Z"  stroke="rgba(0,0,0,0)" stroke-width="1" opacity="0"/>
                <path :id="generatedID + '_Path_63'" :class="svgFillClass" data-name="Path 63" d="M19,6.41,17.59,5,12,10.59,6.41,5,5,6.41,10.59,12,5,17.59,6.41,19,12,13.41,17.59,19,19,17.59,13.41,12Z" fill="#fff" stroke="rgba(0,0,0,0)" stroke-width="1"/>
            </g>
        </g>
    </svg>
</template>

<script>
import { v4 as uuidv4 } from 'uuid';
export default {
    name: "closeIcon",

    props: {
      width: {
          type: Number,
          default: 24
      },

      height: {
          type: Number,
          default: 24
      },

      svgFillClass: {
          type: String,
          default: 'svg-on-primary-color'
      }
    },

    computed: {
        generatedID() {
            return uuidv4();
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/common/components/svg/shared/closeIcon.vue